window.addEventListener("load", function () {    
    $(".popup_getlist .btn_get").each(function() {
        if ($(this).hasClass("received")) {
        
            $(this).text("Đã Nhận");
        } else {
            $(this).text("Nhận Lượt");
        }
    });
});
